<template>
  <div class="card">
    <div class="card__title">
      <h5>Información del comprobante</h5>
    </div>
    <div class="card__content">
      <div class="row">
        <div
          v-show="tipoComprobante === codigoNotaCredito"
          class="col-xs-12 col-md-6"
        >
          <div class="form-field">
            <div class="form-group">
              <input-field
                :disabled="disabled || modelValue.estado !== 'N'"
                :readonly="modelValue.tipo_comprobante_afectado !== ''"
                v-model="modelValue.numero_comprobante_afectado"
                type="tel"
                v-mask="'###-###-#########'"
                id="comprobanteAfectado"
                placeholder="N° comprobante"
              >
                <span>Comprobante afectado</span>
                <span
                  v-if="
                    errores.hasOwnProperty(
                      'cabecera.numero_comprobante_afectado'
                    )
                  "
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{
                    errores["cabecera.numero_comprobante_afectado"][0]
                  }}</strong>
                </span>
              </input-field>
              <button
                :disabled="disabled || modelValue.estado !== 'N'"
                v-show="
                  modelValue.tipo_comprobante_afectado === '' &&
                    modelValue.estado === 'N'
                "
                class="btn-info"
                type="button"
                @click="consultarComprobantesCompra"
              >
                <i class="fa fa-search"></i>
              </button>
              <button
                :disabled="disabled || modelValue.estado !== 'N'"
                @click="quitarComprobanteAfectado"
                v-show="
                  modelValue.tipo_comprobante_afectado !== '' &&
                    modelValue.estado === 'N'
                "
                class="btn-danger"
              >
                <i class="fa fa-ban"></i>
              </button>
            </div>
          </div>
        </div>
        <div
          v-show="tipoComprobante === codigoNotaCredito"
          class="col-xs-12 col-md-6"
        >
          <div class="form-field">
            <div class="datepicker-field">
              <VueCtkDateTimePicker
                :disabled="modelValue.tipo_comprobante_afectado !== ''"
                id="fecha_emision_comprobante_afectado"
                v-model="modelValue.fecha_emision_comprobante_afectado"
                locale="es"
                no-label
                only-date
                auto-close
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                label="Seleccione una fecha..."
              />
              <label for="fecha_emision_comprobante_afectado"
                >Fecha de emisión del comprobante *</label
              >
              <span
                v-if="
                  errores.hasOwnProperty(
                    'cabecera.fecha_emision_comprobante_afectado'
                  )
                "
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{
                  errores["cabecera.fecha_emision_comprobante_afectado"][0]
                }}</strong>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div
            :class="{
              'select2--disabled':
                disabled || modelValue.tipo_comprobante_afectado !== '',
            }"
            class="form-field select2"
          >
            <div class="select2-field">
              <v-select
                @input="inputTipoDocumento"
                v-model="selectedTipoDocumento"
                id="tipoDocumento"
                placeholder="Seleccione..."
                :options="tiposDocumento"
                label="descripcion"
              ></v-select>
              <label for="tipoDocumento">Tipo de documento</label>
              <span
                v-if="errores.hasOwnProperty('cabecera.tipo_documento')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores["cabecera.tipo_documento"][0] }}</strong>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-inline">
            <label for="manual">
              <input
                :disabled="disabled"
                v-model="modelValue.tipo"
                value="M"
                type="radio"
                id="manual"
              />
              <span>Manual</span>
            </label>
            <label for="electronico">
              <input
                :disabled="disabled"
                v-model="modelValue.tipo"
                value="E"
                type="radio"
                id="electronico"
              />
              <span>Electrónico</span>
            </label>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-inline">
            <label for="mybillbot">
              <input
                disabled
                v-model="modelValue.mybillbot"
                type="checkbox"
                id="mybillbot"
              />
              <span>Importado por MyBillBot</span>
            </label>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <input-field
            :disabled="disabled"
            v-mask="'###-###-#########'"
            id="numeroDocumento"
            placeholder="###-###-#########"
            v-model="modelValue.numero_documento"
          >
            Número de documento
            <span
              v-if="errores.hasOwnProperty('cabecera.numero_documento')"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores["cabecera.numero_documento"][0] }}</strong>
            </span>
          </input-field>
        </div>
        <div class="col-xs-12 col-md-4">
          <input-field
            :disabled="disabled"
            placeholder="Clave de SRI"
            :readonly="modelValue.tipo === 'M' || modelValue.mybillbot"
            id="claveAcceso"
            v-model="modelValue.clave_acceso"
          >
            Clave de acceso
            <span
              v-if="errores.hasOwnProperty('cabecera.clave_acceso')"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores["cabecera.clave_acceso"][0] }}</strong>
            </span>
          </input-field>
        </div>
        <div class="col-xs-12 col-md-4">
          <input-field
            :disabled="disabled"
            vMoney
            :format="numero"
            :readonly="modelValue.mybillbot"
            placeholder="##########"
            id="numeroAutorizacion"
            v-model="modelValue.numero_autorizacion"
          >
            Número de autorizacion
            <span
              v-if="errores.hasOwnProperty('cabecera.numero_autorizacion')"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores["cabecera.numero_autorizacion"][0] }}</strong>
            </span>
          </input-field>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <div class="datepicker-field">
              <date-picker
                :disabled="disabled"
                :type="tipoFechaAutorizacion"
                :format="formatoFechaAutorizacion"
                id="fechaAutorizacion"
                v-model="modelValue.fecha_autorizacion"
                lang="es"
              ></date-picker>
              <label for="fechaAutorizacion">Fecha de autorización</label>
              <span
                v-if="errores.hasOwnProperty('cabecera.fecha_autorizacion')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores["cabecera.fecha_autorizacion"][0] }}</strong>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <div class="datepicker-field">
              <VueCtkDateTimePicker
                :disabled="disabled"
                id="fecha_emision"
                v-model="modelValue.fecha_emision"
                locale="es"
                no-label
                only-date
                auto-close
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                label="Seleccione una fecha..."
              />
              <label for="fecha_emision">Fecha de emisión</label>
              <span
                v-if="errores.hasOwnProperty('cabecera.fecha_emision')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores["cabecera.fecha_emision"][0] }}</strong>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <div class="form-group">
              <input-field
                :disabled="
                  disabled || modelValue.tipo_comprobante_afectado !== ''
                "
                :readonly="modelValue.id_proveedor !== ''"
                vMoney
                :format="numero"
                placeholder="############"
                v-model="modelValue.numero_identificacion"
                id="numeroIdentificacion"
                >Identificación</input-field
              >
              <button
                :disabled="
                  disabled || modelValue.tipo_comprobante_afectado !== ''
                "
                @click="consultarProveedor"
                v-show="modelValue.id_proveedor === ''"
                class="btn-success"
                type="button"
              >
                <i class="fa fa-check"></i>
              </button>
              <button
                :disabled="
                  disabled || modelValue.tipo_comprobante_afectado !== ''
                "
                @click="quitarProveedor"
                v-show="modelValue.id_proveedor !== ''"
                class="btn-danger"
                type="button"
              >
                <i class="fa fa-ban"></i>
              </button>
              <modal scrollable width="70%" height="auto" name="persona">
                <persona
                  :numeroIdentificacion="modelValue.numero_identificacion"
                  @saved="savedPersona"
                  :searchButton="false"
                ></persona>
              </modal>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <div class="form-group">
              <input-field
                readonly
                v-model="modelValue.nombre_proveedor"
                id="nombreProveedor"
                placeholder="Proveedor"
              >
                Nombre de proveedor
                <span
                  v-if="errores.hasOwnProperty('cabecera.id_proveedor')"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores["cabecera.id_proveedor"][0] }}</strong>
                </span>
              </input-field>
              <button
                :disabled="
                  disabled || modelValue.tipo_comprobante_afectado !== ''
                "
                @click="$modal.show('proveedor')"
                class="btn-info"
                type="button"
              >
                <i class="fa fa-search"></i>
              </button>
              <modal width="55%" height="auto" name="proveedor" scrollable>
                <lista-personas
                  tipoFiltro="P"
                  :filterStatus="false"
                  @selected="selectedProveedor"
                ></lista-personas>
              </modal>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div
            :class="{
              'select2--disabled':
                disabled || modelValue.tipo_comprobante_afectado !== '',
            }"
            class="form-field select2"
          >
            <div class="select2-field">
              <v-select
                v-model="selectedMoneda"
                @input="inputMoneda"
                label="descripcion"
                :options="monedas"
                id="moneda"
                placeholder="Seleccione..."
              ></v-select>
              <label for="moneda">Moneda</label>
              <span
                v-if="errores.hasOwnProperty('cabecera.id_moneda')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ errores["cabecera.id_moneda"][0] }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  updated: function() {
    let that = this;
    let numeroDocumento = document.getElementById("numeroDocumento");
    if (numeroDocumento !== undefined && numeroDocumento !== null)
      numeroDocumento.onblur = function() {
        let parts = numeroDocumento.value.split("-");
        let nuevoNumero = null;
        if (parts.length === 3)
          nuevoNumero =
            parts[0] + "-" + parts[1] + "-" + parts[2].padStart(9, "0");
        else {
          nuevoNumero = numeroDocumento.value
            .replace("-", "")
            .replace("-", "")
            .padStart(15, "0");
          nuevoNumero =
            nuevoNumero.substr(0, 3) +
            "-" +
            nuevoNumero.substr(3, 3) +
            "-" +
            nuevoNumero.substr(6, 9);
        }
        that.modelValue.numero_documento = nuevoNumero;
      };
  },
  props: {
    tipoComprobante: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: function() {
        return {
          clave_acceso: "",
          numero_autorizacion: "",
          numero_documento: "",
          fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
          id_proveedor: "",
          id_moneda: "",
          fecha_autorizacion: "",
          mybillbot: false,
          tipo_documento: "",
          tipo: "E",
          numero_identificacion: "",
          estado: "N",
          nombre_proveedor: "",
          tipo_comprobante: this.tipoComprobante,
          tipo_comprobante_afectado: "",
          numero_comprobante_afectado: "",
          fecha_emision_comprobante_afectado: "",
        };
      },
    },
    monedas: {
      type: Array,
      required: true,
    },
    errores: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    codigoFactura: {
      type: String,
      required: true,
    },
    codigoNotaCredito: {
      type: String,
      required: true,
    },
  },
  computed: {
    formatoFechaAutorizacion: function() {
      if (this.modelValue.tipo === "E") return "yyyy-MM-dd HH:mm:ss";
      else return "yyyy-MM-dd";
    },
    tipoFechaAutorizacion: function() {
      if (this.modelValue.tipo === "E") return "datetime";
      else return "date";
    },
  },
  data: function() {
    return {
      decimales_compras: 2,
      modelValue: this.value,
      tiposDocumento: [
        {
          id: "FA",
          descripcion: "Factura local",
        },
        {
          id: "FR",
          descripcion: "Factura por reembolso",
        },
        {
          id: "LC",
          descripcion: "Liquidación de compras",
        },
        {
          id: "NV",
          descripcion: "Nota de venta",
        },
        {
          id: "RI",
          descripcion: "Factura RISE",
        },
      ],
      selectedTipoDocumento: null,
      numero: numero,
      selectedMoneda: null,
      url: url,
    };
  },
  methods: {
    consultarComprobantesCompra: function() {
      this.$emit("consultar");
    },
    quitarComprobanteAfectado: function() {
      this.modelValue.tipo_comprobante_afectado = "";
      this.modelValue.numero_comprobante_afectado = "";
      this.modelValue.fecha_emision_comprobante_afectado = "";
      this.selectedTipoDocumento = null;
      this.selectedMoneda = null;
      this.modelValue.id_proveedor = "";
      this.modelValue.nombre_proveedor = "";
      this.modelValue.numero_identificacion = "";
      this.$emit("quitarComprobante");
    },
    savedPersona: function(persona) {
      this.modelValue.id_proveedor = persona.id;
      this.modelValue.numero_identificacion = persona.identificacion;
      this.modelValue.nombre_proveedor = persona.nombre;
      this.decimales_compras = persona.decimales_compras;
      this.$emit("decimalesActualizados", this.decimales_compras);
      this.$modal.hide("persona");
    },
    selectedProveedor: function(proveedor) {
      this.modelValue.id_proveedor = proveedor.id;
      this.modelValue.numero_identificacion = proveedor.identificacion;
      this.modelValue.nombre_proveedor = proveedor.nombre;
      this.decimales_compras = proveedor.decimales_compras;
      this.$emit("decimalesActualizados", this.decimales_compras);
      this.$modal.hide("proveedor");
    },
    quitarProveedor: function() {
      this.modelValue.id_proveedor = "";
      this.modelValue.numero_identificacion = "";
      this.modelValue.nombre_proveedor = "";
      this.decimales_compras = 2;
      this.$emit("decimalesActualizados", this.decimales_compras);
    },
    inputTipoDocumento: function() {
      if (
        this.selectedTipoDocumento !== null &&
        this.selectedTipoDocumento !== undefined
      )
        this.modelValue.tipo_documento = this.selectedTipoDocumento.id;
      else this.modelValue.tipo_documento = "";
    },
    inputMoneda: function() {
      if (this.selectedMoneda !== undefined && this.selectedMoneda !== null)
        this.modelValue.id_moneda = this.selectedMoneda.id_moneda;
      else this.modelValue.id_moneda = "";
    },
    crearNuevaPersona: function() {
      this.$modal.show("persona");
    },
    consultarProveedor: function() {
      if (this.modelValue.numero_identificacion !== "") {
        let that = this;
        axios
          .get(
            this.url + "/personas/" + this.modelValue.numero_identificacion,
            {
              params: {
                tipoFiltro: "P",
              },
            }
          )
          .then(function(response) {
            that.modelValue.nombre_proveedor = response.data.nombre;
            that.modelValue.id_proveedor = response.data.id;
          })
          .catch(function(error) {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                let status = response.status;
                if (status === 404) {
                  swal({
                    title: "¿Desear crear una nueva persona?",
                    text: "Esta acción requiere de confirmación.",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: "Nueva persona",
                    cancelButtonText: "No",
                  }).then((result) => {
                    if (result.value) that.crearNuevaPersona();
                  });
                } else
                  swal(
                    "Hubo un error al momento de consultar el número. Intente nuevamente.",
                    "Error",
                    "error"
                  );
              }
            }
          });
      } else
        swal("Debe ingresar un número de identificación.", "Aviso", "warning");
    },
  },
  watch: {
    "value.id_moneda": function(value) {
      if (value !== undefined && value !== null && value !== "")
        for (let i = 0; i < this.monedas.length; i++)
          if (this.monedas[i].id_moneda === value) {
            this.selectedMoneda = this.monedas[i];
            break;
          }
    },
    "value.tipo_documento": function(value) {
      if (value !== undefined && value !== null && value !== "")
        for (let i = 0; i < this.tiposDocumento.length; i++)
          if (this.tiposDocumento[i].id === value) {
            this.selectedTipoDocumento = this.tiposDocumento[i];
            break;
          }
    },
    value: function(value) {
      this.modelValue = value;
      if (value.tipo_documento === "") this.selectedTipoDocumento = null;
      if (value.id_moneda === "") this.selectedMoneda = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/CabeceraCompra.vue